<template>
  <v-chart
    class="chart"
    :option="chartOptions"
    autoresize
    :style="{height: chartHeight + 'px'}"
  />
</template>

<script>
import { use }                 from 'echarts/core'
import VChart from 'vue-echarts'
import { BarChart } from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { toNumberFormatNotationShort } from '@/lib/utils/helper'

use([
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  CanvasRenderer
])

export default {
  name      : 'GapDatasetBar',
  components: {
    VChart
  },
  props: {
  },
  dataStore: {
    ALMSummary: 'ALM.ALMSummary.Data'
  },
  computed: {
    chartHeight () {
      return 300
    },
    gapStackedData () {
      return this.ALMSummary?.gapAnalysisStackedData || []
    },
    currencySymbol () {
      return this.ALMSummary?.currencySymbol || '$'
    },
    chartOptions () {
      const xAxis = this.gapStackedData.map(item => item.label)
      const loansData = this.gapStackedData.map(item => item.loans)
      const depositsData = this.gapStackedData.map(item => item.deposits)
      const investmentsData = this.gapStackedData.map(item => item.investments)

      return {
        animation        : true,
        animationDuration: 1000,
        animationEasing  : 'quinticOut',
        tooltip          : {
          show       : true,
          trigger    : 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let result = `<div style="font-weight: bold; margin-bottom: 8px;">${params[0].axisValue}</div>`
            params.forEach(param => {
              const value = param.value === 0 ? '0' : toNumberFormatNotationShort(Math.abs(param.value))
              const color = param.color
              result += `<div style="display: flex; align-items: center; margin: 4px 0;">
                <span style="display: inline-block; width: 12px; height: 12px; background: ${color}; margin-right: 8px; border-radius: 2px;"></span>
                <span style="font-weight: 500;">${param.seriesName}:</span>
                <span style="margin-left: 8px; font-weight: bold;">${this.currencySymbol}${value}</span>
              </div>`
            })
            return result
          }
        },
        legend: {
          show: false
        },
        grid: {
          left        : 10,
          top         : 40,
          right       : 10,
          bottom      : 10,
          containLabel: true
        },
        xAxis: {
          type     : 'category',
          data     : xAxis,
          axisLabel: {
            show     : true,
            fontSize : 12,
            color    : '#666',
            formatter: (value) => {
              return value
            }
          },
          axisLine : { show: false },
          axisTick : { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type     : 'value',
          axisLabel: {
            show: false
          },
          axisLine : { show: false },
          axisTick : { show: false },
          splitLine: {
            show     : true,
            lineStyle: {
              type : 'dashed',
              color: '#E0E0E0'
            }
          }
        },

        series: [
          {
            name     : 'Loans',
            type     : 'bar',
            data     : loansData,
            itemStyle: {
              color       : '#57C05B',
              borderRadius: [2, 2, 2, 2]
            },
            label: {
              show      : true,
              position  : 'top',
              fontSize  : 10,
              fontWeight: 500,
              color     : '#041F30',
              formatter : (params) => {
                return this.currencySymbol + (params.value === 0 ? '0' : toNumberFormatNotationShort(Math.abs(params.value)))
              }
            },
            barWidth: '37px'
          },
          {
            name     : 'Deposits',
            type     : 'bar',
            data     : depositsData,
            itemStyle: {
              color       : '#3D68D5',
              borderRadius: [2, 2, 2, 2]
            },
            label: {
              show      : true,
              position  : 'top',
              fontSize  : 10,
              fontWeight: 500,
              color     : '#041F30',
              formatter : (params) => {
                return this.currencySymbol + (params.value === 0 ? '0' : toNumberFormatNotationShort(Math.abs(params.value)))
              }
            },
            barWidth: '37px'
          },
          {
            // showBackground: true,
            name     : 'Investments',
            type     : 'bar',
            data     : investmentsData,
            itemStyle: {
              color       : '#EA804B',
              borderRadius: [2, 2, 2, 2]
            },
            label: {
              show      : true,
              position  : 'top',
              fontSize  : 10,
              fontWeight: 500,
              color     : '#041F30',
              formatter : (params) => {
                return this.currencySymbol + (params.value === 0 ? '0' : toNumberFormatNotationShort(Math.abs(params.value)))
              }
            },
            backgroundColor: 'red',
            barWidth       : '37px'
          }
        ]
      }
    }
  },
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods: {}

}
</script>

<style scoped>
.chart {
  width: 100%;
}
</style>
